import React from 'react';
import { VideoPlayer } from './VideoPlayer';
import { CTAButton } from './CTAButton';
import { Header } from './Header';
import { TestimonialsSection } from './TestimonialsSection';
import { Footer } from './Footer';
import { LogoCarousel } from '../ui/LogoCarousel';
export function DealflowFunnel() {
  return <div className="w-full min-h-full bg-dark-900 text-white" data-id="element-298">
      <div className="relative overflow-hidden" data-id="element-299">
        <div className="absolute inset-0 bg-gradient-to-br from-[#00c853]/10 to-transparent" data-id="element-300" />
        <Header data-id="element-301" />
        <div className="max-w-4xl mx-auto px-4 pt-12 pb-8 text-center relative" data-id="element-302">
          <h1 className="text-[1.8rem] sm:text-[1.7rem] md:text-[2.5rem] lg:text-[3rem] font-bold mb-6 leading-[1.2] sm:leading-[1.15]" data-id="element-303">
            We'll Deliver{' '}
            <span className="text-[#00c853]" data-id="element-304">5+ Off-Market LOIs</span> Per Month
            Through Our{' '}
            <span className="text-[#00c853]" data-id="element-305">'Digital Deal Pipeline'</span>{' '}
            That's Already Generated Over{' '}
            <span className="text-[#00c853]" data-id="element-306">$100M</span> In Transaction Volume
          </h1>
          <p className="text-gray-300 text-lg mb-12 max-w-2xl mx-auto" data-id="element-307">
            Watch the video to see how PE firms win better deals by bypassing
            brokers
          </p>
          <div className="mb-12" data-id="element-308">
            <VideoPlayer data-id="element-309" />
          </div>
          <p className="text-gray-300 mb-8" data-id="element-310">
            For PE firms & family offices doing 4+ deals annually
          </p>
          <CTAButton data-id="element-311" />
          <div className="mt-16" data-id="element-312">
            <LogoCarousel logos={['https://uploadthingy.s3.us-west-1.amazonaws.com/4hsFn1bXWgpaJw4eVPXWMu/image_3.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/6Vw9jxVu6Aq81G41yd5ctH/image_7.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/uo5388jZ7YguXpjvgH8wvn/image_9.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/7xrpKvQsuWnM4W1YgYiaBP/image_10.png', 'https://cdn.magicpatterns.com/uploads/mPyeph882JKwjn9RaHTaP9/Chiro_Venture_-_white_no_background_1.png', 'https://cdn.magicpatterns.com/uploads/mxhhN1AVnPTvg368rZGcTh/favicon_update-150x150_1.png']} data-id="element-313" />
          </div>
        </div>
      </div>
      <TestimonialsSection data-id="element-314" />
      <div className="max-w-4xl mx-auto py-20 px-4 text-center" data-id="element-315">
        <CTAButton data-id="element-316" />
      </div>
      <Footer data-id="element-317" />
    </div>;
}